// extracted by mini-css-extract-plugin
module.exports = {"container":"logo_container__2jnwX","primary":"logo_primary__UW__0","white":"logo_white__sIXgB","fade-in":"logo_fade-in__2X5nP"};